import { ArrowLeftIcon } from '@heroicons/react/24/outline';

import { ProgressBar } from '../ProgressBar/ProgressBar';
import { CurrentStep } from './base/CurrentStep';
import { Root } from './base/Root';
import type { WizardProps } from './base/types';
import { useWizardState, WizardProvider } from './base/WizardState';

export function ProgressBarWizard({
  steps,
  testId,
  onStepChange,
}: WizardProps) {
  return (
    <WizardProvider steps={steps} onStepChange={onStepChange}>
      <Root testId={testId}>
        <ProgressBarWizardHeader />
        <CurrentStep />
      </Root>
    </WizardProvider>
  );
}

function ProgressBarWizardHeader() {
  const wizardState = useWizardState();

  return (
    <>
      <div className="flex justify-between">
        <h3 className="flex grow items-center gap-2 text-xl font-medium leading-6 text-gray-900">
          {wizardState.stepNum > 1 ? (
            <ArrowLeftIcon
              onClick={() => wizardState.prev()}
              className="font-heavy h-6 w-6 hover:cursor-pointer"
              data-testid="wizard-back-button"
            />
          ) : null}
          {wizardState.currentStep.title}
        </h3>
        <div className="flex w-[50%] items-center">
          <ProgressBar
            step={wizardState.stepNum}
            total={wizardState.totalSteps}
          />
        </div>
      </div>
      {wizardState.currentStep.description ? (
        <p
          className="mt-1 text-xs text-gray-500"
          data-testid="wizard-step-description"
        >
          {wizardState.currentStep.description}
        </p>
      ) : null}
    </>
  );
}
